module.exports = __webpack_public_path__ + "8009bf9cc992723ae7a75c88c725dac5.svg";